import request from '@/utils/request'
import qs from 'qs'

/**
 * 创建企业
 * @param companyId
 */
export function create(param) {
  return request({
    url: '/api/company/create',
    method: 'post',
    data: param
  })
}
/**
 * 加入企业
 * @param companyId
 */
export function join(companyId) {
  return request({
    url: '/api/company/join/' + companyId,
    method: 'post',
  })
}

/**
 * 获取用户的主公司
 */
export function getCompany() {
  return request({
    url: '/api/company/fetch/master',
    method: 'get',
  })
}

/**
 * 获取用户的公司列表
 */
export function fetchList() {
  return request({
    url: '/api/company/fetch/list',
    method: 'get',
  })
}

/**
 * 切换公司
 */
export function switchCompany(companyId) {
  return request({
    url: `/api/company/switch/${companyId}`,
    method: 'post',
  })
}


/**
 * 企业管理
 */
/**
 * 企业管理列表
 * @param query
 */
export function companyList(query) {
  return request({
    url: '/api/company/list',
    method: 'post',
    data: query
  })
}
/**
 * 删除
 * @param param
 */
export function remove(param) {
  return request({
    url: '/api/company/delete/' + param,
    method: 'post'
  })
}
/**
 * 修改
 * @param param
 */
export function update(param) {
  return request({
    url: '/api/company/update',
    method: 'post',
    data: param
  })
}


